<template>
  <div class="content-wrapper  solutions">
    <a href="#"/></a>

    <div class="b-solution-in">
      <breadcrumbs :items="breadcrumbs" />

      <h1 class="b-solution__name">Фасад</h1>
      <div class="b-solution__dots">
        <v-img
          class="b-solution__img"
          src="upload/iblock/bf6/bf66b477ed24076937f69e5142d31300.jpg"
          alt=""
          :aspect-ratio="1.629"
        />
        <div data-id="1" class="b-solution__dot" style="top: 70%; left: 17%;">
          1
        </div>

        <div data-id="2" class="b-solution__dot" style="top: 82%; left: 15%;">
          2
        </div>

        <div data-id="3" class="b-solution__dot" style="top: 65%; left: 25%;">
          3
        </div>

        <div data-id="4" class="b-solution__dot" style="top: 63%; left: 42%;">
          4
        </div>

        <div data-id="5" class="b-solution__dot" style="top: 49%; left: 11%;">
          5
        </div>

        <div data-id="6" class="b-solution__dot" style="top: 73%; left: 74%;">
          6
        </div>

        <div data-id="7" class="b-solution__dot" style="top: 83%; left: 60%;">
          7
        </div>

        <div data-id="8" class="b-solution__dot" style="top: 60%; left: 55%;">
          8
        </div>

        <div data-id="9" class="b-solution__dot" style="top: 43%; left: 60%;">
          9
        </div>

        <div data-id="10" class="b-solution__dot" style="top: 30%; left: 48%;">
          10
        </div>
      </div>

      <div class="b-solution__groups">
        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="1">
            <div class="b-solution__group-key">1</div>
            -
            <div class="b-solution__group-name">Добавка для растворов</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/50a/50a4a43e5291bdcfd326d609947669cd.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#"
                    >SikaLatex®</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Добавка для повышения эластичности растворов, устройства
                  тонких стяжек и адгезионных слоёв.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="2">
            <div class="b-solution__group-key">2</div>
            -
            <div class="b-solution__group-name">Очиститель фасадов</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/3c7/3c714f09119bb8f31a37f177b587ae97.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sikagard®-105 EC</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Средство для удаления высолов и солевых отложений
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="3">
            <div class="b-solution__group-key">3</div>
            -
            <div class="b-solution__group-name">Пропитка для фасадов</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/95e/95e5308a24690176fbdb9b284a4f69e0.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sikagard®-703 W</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Гидрофобизирующая пропитка
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="4">
            <div class="b-solution__group-key">4</div>
            -
            <div class="b-solution__group-name">Герметик для окон</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/502/5022c0e686c57164b22d0ba7b187c843.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sikaflex® AT Connection</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Гибридный эластичный герметик для швов
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="5">
            <div class="b-solution__group-key">5</div>
            -
            <div class="b-solution__group-name">Химический анкер</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/79c/79c28f438b62827214006c5bf687f998.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sika® AnchorFix®-3+</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Высокопрочный эпоксидный анкеровочный состав
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="6">
            <div class="b-solution__group-key">6</div>
            -
            <div class="b-solution__group-name">Плиточный клей</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/f3c/f3ccde61564c4471d8812be45557cdee.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >SikaCeram® Elastic</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Плиточный клей для внутренних и внешних работ. Класс C2 TE
                  &#40;ГОСТ Р 56387&#41;. Максимальный размер плитки 150х150 см
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="7">
            <div class="b-solution__group-key">7</div>
            -
            <div class="b-solution__group-name">Ремонтный состав</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/137/1379130d017ebe7de0407a09012f432f.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sikadur®-31 CF Normal</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Универсальный ремонтный состав
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="8">
            <div class="b-solution__group-key">8</div>
            -
            <div class="b-solution__group-name">Шовный герметик</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/561/561248d794ec3831135f338716bf079b.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sikaflex® Construction+</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Полиуретановый однокомпонентный эластичный герметик
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="9">
            <div class="b-solution__group-key">9</div>
            -
            <div class="b-solution__group-name">Клей-герметик</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/ef1/ef1fd365a872f521a2df995fd91595e3.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sikaflex®-11FC+ (i-Сure)</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  2 в 1. Универсальный цветной клей-герметик
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="10">
            <div class="b-solution__group-key">10</div>
            -
            <div class="b-solution__group-name">Кровельный герметик</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/319/319f49a447e4e0ed25fe84594814339b.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#"
                    >Sika® BlackSeal-3</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Шовный герметик на основе битума
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p><a href="#"></a></p>
  </div>
</template>

<script>
export default {
    data() {
    return {
      breadcrumbs: [
        {
          label: "Главная",
          to: {name: "main"},
        },
        {
          label: "Решения для дома",
          to: {name: "solutions"},
        },
        {
          label: "Фасад",
        },
      ],
    };
  },
};
</script>

<style lang="scss"></style>
